import { Component } from '@angular/core';

@Component({
  selector: 'di-grid-card-desc',
  template: '<ng-content />',
  standalone: false,
  host: {
    class: 'tw:block tw:min-h-15',
  },
})
export class GridCardDescComponent {}
